import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import {
  ControllerReEntryButton,
  ControllerReEntryContentHeader,
  ControllerReEntryContentWrapper,
  ControllerReEntryWrapper,
  ControllerSearchMemberPointWrapper,
  ControllerSearchMemberPoint,
  ControllerReEntryUserNameWrapper,
} from "./style";
import { usePaymentTypes } from "../../hooks/usePaymentTypes";
import ControllerReEntryList from "./component/list";
import {
  addOnTournament,
  reBuyInTournament,
  TournamentParticipantRequest,
  PaymentMethod,
  EntryType,
  ParticipantDto,
  ParticipantPaymentRequest,
  getTournamentUserReBuyInHistory,
  getTournamentUserAddOnHistory,
  TournamentParticipantPaymentRequest,
} from "../../../../../../api/tournament-participant";
import { getPubMemberList } from "../../../../../../api/member";
import { pubState } from "../../../../../../recoil/pub.atom";
import { PaymentTypeInput } from "../payment-input";
import { useParticipantContext } from "../../hooks/participant-context";
import { useControllerContext } from "../../../../hooks/controller-context";
import { Const } from "../../../../../../common/const/const";
import { ControllerSitInButtonGroup } from "../../style";
import { exchangePoint } from "../../../../../../utils/number";
import { isTournamentAccess } from "../../../../../../utils/owner";

const ControllerReEntryPopup = () => {
  const { data, level } = useControllerContext();
  const {
    selectedMember,
    reEntryType,
    isReEntryType,
    setIsReEntryPopup,
    reloadData,
    isCount,
  } = useParticipantContext();
  const { id } = useParams();
  const tournamentId = id?.replace(/[^0-9]/g, "");
  const isAddOn = isReEntryType(EntryType.ADD_ON);
  const size = 6;
  const pub = useRecoilValue(pubState);
  const { payType } = usePaymentTypes();

  // 결제할 총 포인트 / 시드
  const [payPoint, setPayPoint] = useState<number>(0);
  const [paySeed, setPaySeed] = useState<number>(0);
  // 멤버 포인트
  const [memberTotalPoint, setMemberTotalPoint] = useState<number>(0);
  // 결제할 총 포인트가 빠진 값
  const [memberResultPoint, setMemberResultPoint] = useState<number>(0);
  // 멤버 시드
  const [memberTotalSeed, setMemberTotalSeed] = useState<number>(0);
  // 결제할 총 시드가 빠진 값
  const [memberResultSeed, setMemberResultSeed] = useState<number>(0);
  // 페이징
  const [totalPage, setTotalPage] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  // 리엔트리 / 애드온 request 리스트
  const [updateRequest, setUpdateRequest] = useState<
    TournamentParticipantRequest[]
  >([]);
  // 리스트 (로컬에서 추가한 값 포함)
  const [list, setList] = useState<ParticipantDto[]>([]);
  // 리스트 (서버에서 가져온 값)
  const [originalItems, setOriginalItems] = useState<ParticipantDto[]>([]);
  // 결제 총 금액
  const [totalPay, setTotalPay] = useState<number>(
    (isAddOn ? data?.addOn : data?.reBuyIn) || 0,
  );
  // 추가 스택
  const [addStack, setAddStack] = useState<number>(0);
  // 연속 클릭 방지
  const [isUpdate, setIsUpdate] = useState<boolean>(false);

  // 메모
  const [memberMemo, setMemberMemo] = useState<string>("");
  const [isHover, setIsHover] = useState<boolean>(false);

  // 현재 input에 있는 포인트, 시드 값
  const point = payType.find(
    (item) => item.type === PaymentMethod.POINTS,
  )?.value;
  const seed = payType.find((item) => item.type === PaymentMethod.SEED)?.value;

  // 리엔트리 / 애드온 업데이트
  const updateItems = async (reqPayType?: TournamentParticipantRequest[]) => {
    if (!selectedMember || !tournamentId) return;
    if (!isTournamentAccess(+tournamentId, pub?.tournamentIds)) {
      alert(`토너먼트 ID ${tournamentId}에 대한 권한이 없습니다. `);
      return;
    }
    if (
      updateRequest.length === 0 &&
      (!reqPayType || reqPayType?.length === 0)
    ) {
      setIsReEntryPopup(false);
      return;
    }
    if (isUpdate) return;
    let req = {
      requests: updateRequest,
      memberId: selectedMember.memberId,
      deleteIds: [],
      isCount: isAddOn ? isCount : false,
    };
    if (reqPayType && reqPayType.length > 0) {
      req = {
        ...req,
        requests: reqPayType,
      };
    }
    try {
      setIsUpdate(true);
      isAddOn ? await addOnTournament(req) : await reBuyInTournament(req);
      reloadData();
      alert("저장되었습니다. ");
      setIsReEntryPopup(false);
    } catch (e: any) {
      if (e.status === 403) {
        alert(e.response.data.message);
        return;
      }
      alert(e.message);
    }
  };

  // 결제 금액 확인
  const checkRegisterInput = (value: number | undefined, sum: number) => {
    if (!value) return;
    if (value !== sum) {
      alert(`결제 금액을 확인해주세요.`);
      return false;
    }

    if (memberResultPoint < 0) {
      if (point && point > 0) {
        alert(`회원의 매장이용권가 부족합니다. `);
        return false;
      }
    }
    if (memberResultSeed < 0) {
      if (seed && seed > 0) {
        alert(`회원의 크레딧이 부족합니다. `);
        return false;
      }
    }
    return true;
  };

  // 로컬에서 리엔트리 / 애드온 추가
  const registerItem = () => {
    if (!selectedMember || !tournamentId || !pub) return;

    // 결제 정보 request 변환
    const paymentRequest: ParticipantPaymentRequest[] = [];
    for (const type of payType) {
      if (type.value === 0 || type.value === null) continue;
      paymentRequest.push({
        paymentMethod: type.type,
        paymentAmount: type.value,
      });
    }
    const sum = paymentRequest.reduce((a, b) => a + b.paymentAmount, 0);

    if (sum <= 0) {
      alert("총 결제 금액은 0보다 커야합니다. ");
      return;
    }

    // 결제 가능 여부
    if (!checkRegisterInput(isAddOn ? data?.addOn : data?.reBuyIn, sum)) return;

    // 결제 request 변환 후 request 리스트에 값 추가
    const newReBuy = {
      memberId: selectedMember.memberId,
      pubId: pub.id,
      tournamentId: +tournamentId,
      level: +level === 0 ? 1 : level,
      entryType: reEntryType,
      paymentMethodRequests: paymentRequest,
      description: "",
      addStack: addStack,
    };
    setUpdateRequest((prevReq) => [...prevReq, newReBuy]);

    // 총 결제 포인트 / 시드 초기화
    const resultPoint = memberTotalPoint - payPoint;
    const resultSeed = memberTotalSeed - paySeed;
    setMemberTotalPoint(resultPoint);
    setMemberTotalSeed(resultSeed);

    // input값 전체 초기화
    payType.forEach((item) => {
      item.set(0);
    });

    // 결제값 초기화
    setPayPoint(0);
    setPaySeed(0);
    setAddStack(0);
  };

  // 포인트, 시드 값 조회
  const getMemberPoint = async () => {
    if (!selectedMember || !pub) return;

    try {
      const res = await getPubMemberList(selectedMember.nickname, pub.id);
      const member = res.memberList.find(
        (item) => item.memberId === selectedMember.memberId,
      );
      setMemberMemo(member?.memo || "");
      setMemberResultPoint(member?.point || 0);
      setMemberTotalPoint(member?.point || 0);
      setMemberResultSeed(member?.seed || 0);
      setMemberTotalSeed(member?.seed || 0);
    } catch (e: any) {
      alert(e.message);
      return;
    }
  };

  useEffect(() => {
    getMemberPoint();
  }, []);

  // 결제에 따른 포인트, 시드 값 수정
  useEffect(() => {
    const result = memberTotalPoint - payPoint;
    setMemberResultPoint(result);
  }, [payPoint]);

  useEffect(() => {
    const result = memberTotalSeed - paySeed;
    setMemberResultSeed(result);
  }, [paySeed]);

  // 로컬 리엔트리 / 애드온 삭제
  const deleteItem = (item: ParticipantDto, index: number) => {
    // request에서 삭제
    setUpdateRequest((prev) => prev.filter((_, i) => i !== index));

    // 포인트, 시드 값 초기화
    let point = memberResultPoint;
    let seed = memberResultSeed;
    item.paymentMethodRequests.forEach((pay) => {
      if (pay.paymentMethod === PaymentMethod.POINTS) {
        point += pay.paymentAmount;
      }
      if (pay.paymentMethod === PaymentMethod.SEED) {
        seed += pay.paymentAmount / Const.SEED_RATE;
      }
    });
    setMemberResultSeed(seed);
    setMemberResultPoint(point);
    setMemberTotalSeed(seed);
    setMemberTotalPoint(point);
    setPayPoint(0);
    setPaySeed(0);
  };

  // request + 서버 list 업데이트
  const handlerList = () => {
    const requestList: ParticipantDto[] = updateRequest.map((item, index) => {
      return {
        ...item,
        createdAt: new Date(),
        id: -(index + 1),
        entryType: isAddOn ? EntryType.ADD_ON : EntryType.RE_BUY,
        paymentAmount: item.paymentMethodRequests.reduce(
          (sum, req) =>
            sum +
            (req.paymentMethod === PaymentMethod.DISCOUNT
              ? 0
              : req.paymentAmount || 0),
          0,
        ),
      };
    });

    const combinedList: ParticipantDto[] = [...requestList, ...originalItems];
    setTotalPage(Math.max(1, Math.ceil(combinedList.length / size)));
    setList(combinedList.slice((currentPage - 1) * size, currentPage * size));
  };

  // 페이지, request 리스트 바귈 때마다 list 업데이트
  useEffect(() => {
    handlerList();
  }, [currentPage, updateRequest]);

  // 초기 리스트
  useEffect(() => {
    getList();
  }, [selectedMember]);

  // 리스트 조회
  const getList = async () => {
    if (!tournamentId || !selectedMember) return;
    const res = isAddOn
      ? await getTournamentUserAddOnHistory(
          selectedMember.memberId,
          +tournamentId,
        )
      : await getTournamentUserReBuyInHistory(
          selectedMember.memberId,
          +tournamentId,
        );

    // request에 맞게 response 수정
    const mappedRes = res.map((item) => ({
      ...item,
      paymentMethodRequests: item.participantPaymentMethod.map((payment) => ({
        ...payment,
        paymentAmount: payment.amount,
      })),
    }));
    // 기존 리스트
    setOriginalItems(mappedRes);
    // request 리스트
    setUpdateRequest([]);
    // 페이징
    setCurrentPage(1);
    setTotalPage(Math.max(1, Math.ceil(mappedRes.length / size)));
    setList(mappedRes.slice((currentPage - 1) * size, currentPage * size));
  };

  const checkPay = () => {
    if (totalPay === 0) {
      if (memberResultPoint < 0 && point && point > 0) {
        return false;
      }
      if (memberResultSeed < 0 && seed && seed > 0) {
        return false;
      }
      return true;
    }
    return false;
  };

  const handlePayFull = (index: number) => {
    if (!data || !selectedMember || !pub) {
      return;
    }
    const buyIn = isAddOn ? data?.addOn : data?.reBuyIn;
    if (!buyIn) return;

    payType.forEach((item, i) => {
      const isTarget = i === index;
      const valueToSet = isTarget ? buyIn : 0;

      item.set(valueToSet);

      if (item.unit === "E" && setPayPoint) {
        setPayPoint(valueToSet);
      } else if (item.unit === "RABBIT" && setPaySeed) {
        setPaySeed(isTarget ? buyIn / Const.SEED_RATE : 0);
      }
    });

    const paymentRequest: TournamentParticipantPaymentRequest[] = [];
    payType.forEach((item, i) => {
      const isTarget = i === index;
      const valueToSet = isTarget ? buyIn : 0;

      if (valueToSet === 0) return;
      paymentRequest.push({
        paymentMethod: item.type,
        paymentAmount: valueToSet,
      });
    });

    const newReBuy = {
      memberId: selectedMember.memberId,
      pubId: pub.id,
      tournamentId: +data.id,
      level: +level === 0 ? 1 : level,
      entryType: reEntryType,
      paymentMethodRequests: paymentRequest,
      description: "",
      addStack: addStack,
    };

    updateItems([newReBuy]);
  };

  return (
    <ControllerReEntryWrapper>
      <div className="content-wrapper">
        <ControllerReEntryContentWrapper>
          <div className="title">{isAddOn ? "애드온" : "리엔트리"} 추가</div>
          <ControllerReEntryContentHeader>
            <div>닉네임</div>
            <div className="member-info">
              <ControllerReEntryUserNameWrapper>
                <div className="nickname">{selectedMember?.nickname}</div>
                {memberMemo && (
                  <div className="more">
                    <img
                      alt="more"
                      src="/image-web/solution/more.png"
                      onMouseOver={() => setIsHover(true)}
                      onMouseOut={() => setIsHover(false)}
                    />
                    {isHover && <div className="memo">{memberMemo}</div>}
                  </div>
                )}
              </ControllerReEntryUserNameWrapper>
              <ControllerSearchMemberPointWrapper>
                <ControllerSearchMemberPoint>
                  <div className="name">보유 매장 이용권</div>
                  <div className="value">
                    {exchangePoint(memberResultPoint)} E
                  </div>
                </ControllerSearchMemberPoint>
                <ControllerSearchMemberPoint>
                  <div className="name">보유 크레딧</div>
                  <div className="value">
                    {memberResultSeed?.toLocaleString()} RABBIT
                  </div>
                </ControllerSearchMemberPoint>
              </ControllerSearchMemberPointWrapper>
            </div>
          </ControllerReEntryContentHeader>
          <PaymentTypeInput
            payType={payType}
            setTotalPay={setTotalPay}
            buyIn={isAddOn ? data?.addOn : data?.reBuyIn}
            setPayPoint={setPayPoint}
            setPaySeed={setPaySeed}
            totalPay={totalPay}
            addStack={addStack}
            setAddStack={setAddStack}
            handleBuyIn={() => !isUpdate && registerItem()}
            handlePayFull={handlePayFull}
          />
          <ControllerReEntryButton
            on={checkPay()}
            onClick={() => registerItem()}
          >
            추가하기
          </ControllerReEntryButton>
        </ControllerReEntryContentWrapper>
        <ControllerReEntryList
          isAddOn={isAddOn}
          list={list}
          isCount={isCount}
          totalPage={totalPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          deleteItem={deleteItem}
        />
      </div>
      <ControllerSitInButtonGroup
        buttonWidth="238px"
        width="calc(100% - 100px)"
      >
        <div
          className={`button ${updateRequest.length === 0 ? "gray" : "purple"}`}
          onClick={() => {
            !isUpdate && updateItems();
          }}
        >
          저장
        </div>
        <div className="button" onClick={() => setIsReEntryPopup(false)}>
          취소
        </div>
      </ControllerSitInButtonGroup>
    </ControllerReEntryWrapper>
  );
};
export default ControllerReEntryPopup;
